// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_3vh","cls2":"FullScreenPremiumModal-cls2_3_d FullScreenPremiumModal-cls1_3vh"};